import { useLayoutEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SERVER_URL } from "../../util/url";

function NewRecipe() {
    const location = useLocation();
    const navigate = useNavigate();
    const recipeName = location.pathname.substring(26);
    const [recipe, setRecipe] = useState({});
    const [setPoint, setSetPoint] = useState([]);
    const [newParameters, setNewParameters] = useState([{ name: "", value: "", unit: "", tolerance: "" }]);
    const [dataIsLoaded, setDataIsLoaded] = useState(false);
    const [addParameters, setAddParameters] = useState(false);

    const fetchRecipe = async (signal) => {
        await fetch(SERVER_URL + "/recipes?recipe_name=" + location.pathname.substring(26), {
            method: "GET",
            signal: signal,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.data !== null) {
                    recipe.name = data.data[0].recipe_name;
                    recipe.op_id = data.data[0].op_id;
                    setRecipe(data.data[0]);
                }
            })
            .catch((err) => {
                if (err.name === "AbortError") {
                    console.log("request aborted");
                } else {
                    console.log(err);
                }
            });
    };

    const fetchSetpoint = async (signal) => {
        setPoint.length = 0;
        await fetch(SERVER_URL + "/nominalsp?recipe_name=" + recipeName, {
            method: "GET",
            signal: signal,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data !== null) {
                    data.data.forEach((item) => {
                        const param = item["parameter"].split(" impostato");
                        setPoint.push({
                            parameter: param[0],
                            tolerance: item["tolerance"] ? item["tolerance"] : "//",
                            value: item["value"],
                            unit: item["unit"],
                        });
                    });
                }
            })
            .catch((err) => {
                if (err.name === "AbortError") {
                    console.log("request aborted");
                } else {
                    console.log(err);
                }
            });
        setSetPoint([...setPoint]);
    };

    const loadData = (signal) => {
        fetchRecipe(signal);
        fetchSetpoint(signal);
        setDataIsLoaded(true);
    };

    const sendNewParameters = async () => {
        const body = {
            recipe_id: recipe.id,
            setpoint: newParameters,
        };

        await fetch(SERVER_URL + "/insertsetpoint", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data !== null) {
                    if (data.data === "Data entered correctly") {
                        newParameters.length = 1;
                        setAddParameters(false);
                        setDataIsLoaded(false);
                        setTimeout(() => {
                            loadData(null);
                        }, 100);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleClickCancel = () => {
        newParameters.length = 1;
        setAddParameters(false);
    };

    const handleClickConfirmRecipe = async () => {
        await fetch(SERVER_URL + "/updaterecipeinfo", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                name: recipeName,
                info: "check",
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.data && data.data === "done") {
                    navigate("/homepage/recipeslist");
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useLayoutEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        loadData(signal);

        return () => {
            controller.abort();
        };
    }, []);

    return (
        <div className={"recipe p-5 bg-light " + (dataIsLoaded ? null : "d-flex align-items-center")}>
            {dataIsLoaded ? (
                <div>
                    <div className="d-flex">
                        <div className="d-flex">
                            <p className="fw-bold fs-4 text-secondary my-auto me-2"> Macchina </p>
                            <p className="fw-bold fs-4 text-secondary text-decoration-underline my-auto me-3"> {recipe.machine_name} </p>
                            {addParameters ? (
                                <button type="button" className="btn btn-danger my-2 mx-4" onClick={handleClickCancel}>
                                    ANNULLA
                                </button>
                            ) : (
                                <button type="button" className="btn btn-light my-2" onClick={() => setAddParameters(true)}>
                                    <p className="m-0 fs-6 fw-bold"> VAI ALLA SCHEDA PARAMETRI </p>
                                </button>
                            )}
                            {addParameters ? (
                                <button type="button" className="btn btn-success my-2 mx-4" onClick={sendNewParameters}>
                                    INVIA
                                </button>
                            ) : null}
                        </div>
                        {!addParameters && (
                            <div className="mx-2">
                                <button type="button" className="btn btn-success my-2" style={{ backgroundColor: "#298683" }} data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                                    <p className="m-0 fs-6"> SALVA COME RICETTA STANDARD </p>
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="my-1">
                        <p className="fw-bold fs-4 my-auto"> Setpoint List </p>
                    </div>
                    <div className="card p-2">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">
                                        <p className="m-0  fs-6 text-secondary">PARAMETRI</p>
                                    </th>
                                    <th scope="col">
                                        <p className="m-0 fs-6 text-secondary">VALORE</p>
                                    </th>
                                    <th scope="col">
                                        <p className="m-0 fs-6 text-secondary">TOLLERANZA</p>
                                    </th>
                                    <th scope="col">
                                        <p className="m-0 fs-6 text-secondary">UNITÀ</p>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                
                                {!addParameters && setPoint.length === 0 && (
                                    <tr>
                                        <td colSpan={4} className="text-center">
                                            <p className="m-0 mt-1 fst-italic"> Non sono presenti parametri </p>
                                        </td>
                                    </tr>
                                )}
                                {addParameters
                                    ? newParameters.map((item, index) => {
                                          return (
                                              <tr key={index}>
                                                  <td>
                                                      <input onChange={(e) => (newParameters[index].name = e.currentTarget.value)} />
                                                  </td>
                                                  <td>
                                                      <input type="number" min={1} onChange={(e) => (newParameters[index].value = e.currentTarget.value)} />
                                                  </td>
                                                  <td>
                                                      <input type="number" min="1" onChange={(e) => (newParameters[index].tolerance = e.currentTarget.value)} />
                                                  </td>
                                                  <td>
                                                      <input onChange={(e) => (newParameters[index].unit = e.currentTarget.value)} />
                                                  </td>
                                              </tr>
                                          );
                                      })
                                    : setPoint.map((item, index) => {
                                          return (
                                              <tr key={index}>
                                                  <td>
                                                      <p className="m-0 mt-1"> {item["parameter"]} </p>
                                                  </td>
                                                  <td>
                                                      <p className="m-0 mt-1"> {item["value"]} </p>
                                                  </td>
                                                  <td>
                                                      <p className="m-0 mt-1"> {item["tolerance"]} </p>
                                                  </td>
                                                  <td>
                                                      <p className="m-0 mt-1"> {item["unit"]} </p>
                                                  </td>
                                              </tr>
                                          );
                                      })}
                            </tbody>
                        </table>
                    </div>
                    {addParameters ? (
                        <div className="my-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => {
                                    setNewParameters([...newParameters, { name: "", value: "", unit: "", tolerance: "" }]);
                                }}>
                                Aggiungi parametro
                            </button>
                        </div>
                    ) : null}
                    <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title fs-5" id="staticBackdropLabel">
                                        Conferma
                                    </h1>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    Vuoi rendere la seguente ricetta standard <br />
                                    <p className="m-0 fw-bold"> {recipe["recipe_name"]} </p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                        Annulla
                                    </button>
                                    <button type="button" className="btn btn-primary" style={{ backgroundColor: "#298683" }} onClick={handleClickConfirmRecipe} data-bs-dismiss="modal">
                                        Conferma
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="box mx-auto">
                    <div className="text-center">
                        <div className="spinner-border text-primary my-2" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p>Caricamento dei dati ...</p>
                    </div>
                </div>
            )}
        </div>
    );
}

export default NewRecipe;
